// ----------------------------------------------------------------------

const MuiLink = {
  /** **************************************
   * DEFAULT PROPS
   *************************************** */
  defaultProps: { underline: 'always', sx: { cursor: 'pointer' } },

  /** **************************************
   * STYLE
   *************************************** */
  styleOverrides: {}
}

// ----------------------------------------------------------------------

export const link = { MuiLink }
